import {
  isPartnerProgramKind,
  type OrganizationType,
  type PackageSource,
  type PartnerProgramDomainSelectModel,
  PartnerProgramKindSchema,
} from '@mntn-dev/domain-types'

import { PackageBillingMethods } from '../package-billing.ts'

export const getPackageBillingMethodsByPartnerPrograms = (input: {
  packageSource: PackageSource
  organizationType: OrganizationType
  partnerPrograms?: Array<PartnerProgramDomainSelectModel>
}) => {
  const packageBillingMethods = PackageBillingMethods.get(input.packageSource)
    .filter((m) => isPartnerProgramKind(m))
    .map((m) => PartnerProgramKindSchema.parse(m))

  if (input.organizationType === 'internal') {
    return packageBillingMethods
  }

  const enabledPartnerPrograms = (input.partnerPrograms ?? []).map(
    (program) => program.partnerProgramKind
  )

  return packageBillingMethods.filter((method) =>
    enabledPartnerPrograms.includes(method)
  )
}
